<template>
  <a-card>
    <div class="table-page-search-wrapper">
      <a-form-model layout="inline" :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }">
        <a-row :gutter="16">
          <a-col :span="6">
            <a-form-model-item :label="this.$t('字典名称')">
              <a-input v-model="queryParams.name" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="this.$t('字典编码')">
              <a-input v-model="queryParams.code" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('应用')">
              <a-select v-model="queryParams.appId" :options="appOptions" allowClear />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item>
              <a-button type="primary" @click="handleRefresh(true)">{{ $t('查询') }}</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <div>
      <a-button type="primary" @click="handleAdd">{{ $t('新增') }}</a-button>
      <a-button type="primary" @click="handleImport" style="margin-left: 10px;">{{ $t('导入') }}</a-button>
    </div>
    <a-table rowKey="id" :pagination="pagination" :columns="columns" :dataSource="dataSource" @change="handleTableChange">
      <div slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">{{ $t('编辑') }}</a>    
        <a-divider type="vertical" />
        <a @click="handleEditContent(record)">{{ $t('内容') }}</a>    
        <a-divider type="vertical" />
        <a-popconfirm :title="$t('确认删除吗？')" @confirm="handleDelete(record)">
          <a style="color: red;">{{ $t('删除') }}</a>
        </a-popconfirm>
      </div>
    </a-table>
    <DictEditModal ref="edit" @ok="handleRefresh" />
    <DictContentListModal ref="content" />
    <DictImportModal ref="import" @ok="handleRefresh" />
  </a-card>
</template>
<script>
import { getDictList, removeDict } from '@/api/system/dict'
import { getAppListForCurrentUser } from '@/api/app/app'
import DictEditModal from './modals/DictEditModal.vue'
import DictContentListModal from './modals/DictContentListModal.vue'
import DictImportModal from './modals/DictImportModal'
import { getLabelFromOptions } from '@/utils/dictUtils'

export default {
  components: {
    DictEditModal,
    DictContentListModal,
    DictImportModal
  },
  data() {
    return {
      queryParams: {},
      appOptions: [],
      dataSource: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        showTotal: total => this.$t('共n条数据', [total])
      },
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('字典名称'),
          dataIndex: 'name',
        },
        {
          title: this.$t('字典编码'),
          dataIndex: 'code',
        },
        {
          title: this.$t('备注'),
          dataIndex: 'remark',
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          width: 200,
          scopedSlots: { customRender: 'action' }
        }
      ]
    },
  },
  mounted() {
    this.handleRefresh()
    this.loadOptions()
  },
  methods: {
    handleRefresh(toFirstPage = false) {
      this.loadTableData({ pageNum: toFirstPage ? 1 : this.pagination.current, pageSize: this.pagination.pageSize, ...this.queryParams })
    },
    handleTableChange(page) {
      if (page.current == this.pagination.current) {
        return
      }
      this.loadTableData({ pageNum: page.current, pageSize: page.pageSize, ...this.queryParams })
    },
    loadTableData(params) {
      getDictList({ ...params }).then(res => {
        if (res.code === 0) {
          this.pagination.current = res.data.pageNum
          this.pagination.total = res.data.total
          this.dataSource = res.data.items
        } else {
          this.$message.error(res.message || this.$t('获取数据失败'))
        }
      })
    },
    loadOptions() {
      getAppListForCurrentUser().then(res => {
        this.appOptions = res.data?.map(e => ({ label: e.name, value: e.id })) ?? []
      })
    },
    handleAdd() {
      this.$refs.edit.show()
    },
    handleEdit(record) {
      this.$refs.edit.show(record)
    },
    handleEditContent(record) {
      this.$refs.content.show(record)
    },
    handleDelete(record) {
      removeDict([record.id]).then(res => {
        if (res.code === 0) {
          this.handleRefresh()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleImport() {
      const appId = this.queryParams.appId
      const appName = getLabelFromOptions(appId, this.appOptions, appId)
      this.$refs.import.show({ id: appId, name: appName })
    },
  }
}
</script>